export interface RedirectionTokenLike {
  partnerName?: string;
}

export interface RedirectionTokenStore {
  peekAll: (
    modelName: 'redirection-token' | 'register-redirection-token'
  ) => RedirectionTokenLike[];
}

/**
 * Returns the first redirection token held in the Ember store, preferring the
 * `redirection-token` model and falling back to `register-redirection-token`.
 * Both models carry the partner that initiated the onboarding.
 */
export function getRedirectionToken(
  store: RedirectionTokenStore
): RedirectionTokenLike | undefined {
  return store.peekAll('redirection-token')[0] ?? store.peekAll('register-redirection-token')[0];
}
